import rem from 'polished/lib/helpers/rem'
import * as React from 'react'
import styled from 'styled-components'

// Display flex just as a fallback
const Root = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  display: grid;
  margin: 0;
  grid-gap: ${rem(16)};

  @media (min-width: 576px) {
    grid-template-columns: repeat(auto-fill, minmax(${rem(256)}, 1fr));
  }

  @media (min-width: 1196px) {
    margin-block: ${rem(-20)} 0;
    margin-inline: -${rem(16)};
    grid-template-columns: repeat(auto-fill, minmax(${rem(364)}, 1fr));
    grid-gap: 0;
  }
`

const Wrapper = styled.div`
  display: flex;
  justify-content: start;

  & > * {
    width: 100%;
  }

  @media (min-width: 576px) {
    justify-content: center;

    & > * {
      width: ${rem(348)};
      min-height: ${rem(416)};
    }
  }

  @media (min-width: 1196px) {
    margin-top: ${rem(20)};
  }
`

interface Props {
  children: React.ReactNode
}

function CalendarPickerGridLayout(props: Props) {
  return (
    <Root data-testid="flexwrap-recommendations">
      {React.Children.map(props.children, (child) => (
        <Wrapper>
          {child}
        </Wrapper>
      ))}
    </Root>
  )
}

export default CalendarPickerGridLayout
